import { createSelector } from 'reselect';
import { mapWithDefault } from 'utils/dataMapper';

const selectWizard = (state) => state.get('wizard');

const makeSelectCurrentStep = () =>
  createSelector(selectWizard, (state) =>
    mapWithDefault(state, () => state.get('currentStep'), 0)
  );

const makeSelectDirection = () =>
  createSelector(selectWizard, (state) =>
    mapWithDefault(state, () => state.get('direction'), '')
  );

const makeToggleModal = () =>
  createSelector(selectWizard, (state) =>
    mapWithDefault(state, () => state.get('modalState'), '')
  );

const makeSelectSteps = () =>
  createSelector(selectWizard, (wizardState) =>
    wizardState.get('steps').toJS()
  );

const makeSelectErrors = () =>
  createSelector(selectWizard, (wizardState) =>
    wizardState.get('errors').toJS()
  );

const makeSelectSlider = () =>
  createSelector(selectWizard, (wizardState) => wizardState.get('slider'));

const makeSelectVisitedStep = () =>
  createSelector(selectWizard, (wizardState) => wizardState.get('visitedStep'));

const makeSelectSaveFormStatus = () =>
  createSelector(selectWizard, (wizardState) => wizardState.get('formSaving'));

const makeSelectProgressIndicators = () =>
  createSelector(selectWizard, (wizardState) => wizardState.get('indicators'));

const makeSelectNoBenefitError = () =>
  createSelector(selectWizard, (wizardState) =>
    wizardState.get('noBenefitError')
  );

const makeSelectWizardSteps = () =>
  createSelector(selectWizard, (wizardState) =>
    mapWithDefault(wizardState, () => wizardState.get('wizardSteps').toJS(), [])
  );
const makeSelectInvalidFileName = () =>
  createSelector(selectWizard, (wizardState) =>
    wizardState.get('invalidFileName')
  );

export {
  selectWizard,
  makeSelectCurrentStep,
  makeSelectDirection,
  makeToggleModal,
  makeSelectSteps,
  makeSelectErrors,
  makeSelectSlider,
  makeSelectVisitedStep,
  makeSelectSaveFormStatus,
  makeSelectProgressIndicators,
  makeSelectNoBenefitError,
  makeSelectWizardSteps,
  makeSelectInvalidFileName,
};



// WEBPACK FOOTER //
// ./app/containers/Wizard/selectors.js